import { render, staticRenderFns } from "./AccountDetailsComponent.vue?vue&type=template&id=413ad539&"
import script from "./AccountDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./AccountDetailsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports